<div class="ts-card">
    <h2 class="ts-card-title page-title">Allocations Log</h2>
    <app-view-log-search></app-view-log-search>
    <ng-container *ngIf="!loading && searchExecuted">
        <ng-container *ngIf="totalRecords > 0; else noRecordsFound">
            <table class="ts-table">
                <thead>
                    <tr>
                        <th class="text-right-numeric header-vertical-border">Account</th>
                        <th class="header-vertical-border">User</th>
                        <th class="header-vertical-border">Symbol</th>
                        <th class="header-vertical-border">Side</th>
                        <th class="text-right-numeric header-vertical-border">Price</th>
                        <th class="text-right-numeric header-vertical-border">Quantity</th>
                        <th class="header-vertical-border">Time Stamp</th>
                        <th class="header-vertical-border">Allocated By</th>
                        <th class="header-vertical-border">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of pagedElements$ | async">
                        <td class="text-right-numeric">
                            <a [routerLink]="['/account/account-detail', element.account]">{{ element.account }}</a>
                        </td>
                        <td>{{element.user}}</td>
                        <td>{{element.symbol}}</td>
                        <td>{{element.side}}</td>
                        <td class="text-right-numeric">{{element.price | currency}}</td>
                        <td class="text-right-numeric">{{element.quantity}}</td>
                        <td>{{dateTimeHelper.parseDateToDateTimeString($any(element.timestamp))}}</td>
                        <td>{{element.allocatedBy}}</td>
                        <td>{{getActionString(element)}}</td>
                    </tr>
                </tbody>
            </table>
            <app-paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
                (page)="pageChangeEvent($event)" [pageSizeOptions]="[25, 50, 100, 500]"></app-paginator>
        </ng-container>
    </ng-container>
    <ng-template #noRecordsFound>
        <app-empty-state
            [icon]="faClockRotateLeft"
            headline="No log entries found"
            hint="No allocation activity matches your search. Try a different date range."></app-empty-state>
    </ng-template>
    <app-empty-state *ngIf="!loading && !searchExecuted"
        [icon]="faMagnifyingGlass"
        headline="Search the allocations log"
        hint="Enter your search criteria above to view log entries."></app-empty-state>
</div>
